[
  {
    "numero": 1,
    "autor": "Ana Vinhas",
    "titulo": "O Potencial dos Produtos com Insetos: Uma Visão do Mercado Food e PetFood",
    "set": "In2Market",
    "ficheiro": 1
  },
  {
    "numero": 2,
    "autor": "Bruna Filipa Faria",
    "titulo": "Barreiras à consolidação de bioindústrias disruptivas: O caso da cadeia de valor dos insetos em Portugal",
    "set": "In2Market",
    "ficheiro": 2
  },
  {
    "numero": 3,
    "autor": "Maria João Monteiro",
    "titulo": "Proteínas alternativas e consumidor",
    "set": "In2Market",
    "ficheiro": 3
  },
  {
    "numero": 4,
    "autor": "José Manual Nunes da Costa",
    "titulo": "Produção, processamento e utilização de insetos de criação na alimentação animal – Enquadramento Legal",
    "set": "In2Market",
    "ficheiro": 4
  },
  {
    "numero": 5,
    "autor": "Nuno Muñoz-Seijas",
    "titulo": "Biorefinería de escaravelhos adultos (Tenebrio molitor) usando tecnologias verdes para obter derivados da quitina, proteína e lipidos",
    "set": "In4.0",
    "ficheiro": 5
  },
  {
    "numero": 6,
    "autor": "Ana P.M. Tavares",
    "titulo": "Extração de proteínas da farinha de Tenebrio molitor utilizando processos mais sustentáveis e eficientes",
    "set": "In4.0",
    "ficheiro": 6
  },
  {
    "numero": 7,
    "autor": "Francisco Oliveira",
    "titulo": "Identificação de pupas mortas de Tenebrio molitor",
    "set": "In4.0",
    "ficheiro": 7
  },
  {
    "numero": 8,
    "autor": "João Nuno Reis",
    "titulo": "Efeitos do uso de subprodutos hortofrutícolas e farinha de peixe na qualidade de pó de inseto comestível",
    "set": "In4.0",
    "ficheiro": 8
  },
  {
    "numero": 9,
    "autor": "Gabriel Correia-Brito",
    "titulo": "Estudo e implementação de uma rede de sensores para um sistema de produção de insetos em grande escala",
    "set": "In4.0",
    "ficheiro": 9
  },
  {
    "numero": 10,
    "autor": "Carolina Ligeiro",
    "titulo": "Exploração da Biorremediação de Estrume com Larvas de Mosca Soldado Negro (Hermetia illucens) em larga-escala",
    "set": "InBioremediation",
    "ficheiro": 10
  },
  {
    "numero": 11,
    "autor": "Joana Oliveira",
    "titulo": "BSFL fluorescentes: uma solução de biossegurança para processos de biorremediação",
    "set": "InBioremediation",
    "ficheiro": 11
  },
  {
    "numero": 13,
    "autor": "Carolina Ligeiro",
    "titulo": "Uso de Larvas da Mosca-soldado-negro (Hermetia illucens) como Solução Sustentável para o Maneio de Estrume",
    "set": "InBioremediation",
    "ficheiro": 13
  },
  {
    "numero": 14,
    "autor": "Maria Ana Machado",
    "titulo": "Consumo de filmes plásticos de PS e PET por larvas de Hermetia illucens",
    "set": "InBioremediation",
    "ficheiro": 14
  },
  {
    "numero": 15,
    "autor": "Luís Madeira",
    "titulo": "Os insetos como agentes de biorremediação de águas residuais",
    "set": "InBioremediation",
    "ficheiro": 15
  },
  {
    "numero": 16,
    "autor": "Ana Carreira",
    "titulo": "Valorização de larvas de mosca soldado negro por biorrefinaria",
    "set": "InBioremediation",
    "ficheiro": 16
  },
  {
    "numero": 17,
    "autor": "Daniel Acebes",
    "titulo": "Óleo de larvas de Mosca Soldado Negro como fonte Lipídica alternativa em alimentos compostos para Robalo e Dourada",
    "set": "InFeed",
    "ficheiro": 17
  },
  {
    "numero": 18,
    "autor": "Jescka Anuaritt Correia Aleixo",
    "titulo": "Caracterização nutricional de farinha de grilo doméstico (Acheta domesticus) no contexto da alimentação animal",
    "set": "InFeed",
    "ficheiro": 18
  },
  {
    "numero": 19,
    "autor": "Rafaela Silva Costa",
    "titulo": "Introdução de uma mistura proteica de Hermetia illucens e Tenebrio molitor em dietas para robalo Europeu: impacto na digestibilidade a diferentes salinidades",
    "set": "InFeed",
    "ficheiro": 19
  },
  {
    "numero": 20,
    "autor": "Sara Moutinho",
    "titulo": "O uso de insetos e spirulina em dietas para a tilápia-do-nilo (Oreochromis niloticus)",
    "set": "InFeed",
    "ficheiro": 20
  },
  {
    "numero": 21,
    "autor": "Tiago Mariano",
    "titulo": "Desempenhos zootécnicos de galinhas poedeiras com incorporação de farinha de mosca-soldado-negro na alimentação",
    "set": "InFeed",
    "ficheiro": 21
  },
  {
    "numero": 22,
    "autor": "Nuno S. A. Pereira",
    "titulo": "Aplicação de imagens hiper-espectrais para a identificação e caracterização de matérias primas derivadas de insetos",
    "set": "InFeed",
    "ficheiro": 22
  },
  {
    "numero": 23,
    "autor": "Mara Parreiras",
    "titulo": "Composição em aminoácidos em farinhas de BSF",
    "set": "InFeed",
    "ficheiro": 23
  },
  {
    "numero": 24,
    "autor": "Ana Monteiro",
    "titulo": "Avaliação do potencial de utilização de farinha de BSF em nutrição de frangos de carne",
    "set": "InFeed",
    "ficheiro": 24
  },
  {
    "numero": 25,
    "autor": "Rui Fortunato",
    "titulo": "Nutrição Canina - primeiro alimento para animais de companhia com proteína animal 100% BSF",
    "set": "InFeed",
    "ficheiro": 25
  },
  {
    "numero": 27,
    "autor": "Ana Vinhas",
    "titulo": "Hambúrgueres Sustentáveis com Ingredientes à Base de Insetos",
    "set": "InFood",
    "ficheiro": 27
  },
  {
    "numero": 28,
    "autor": "Francisco Madail Herdeiro",
    "titulo": "Desenvolvimento de snacks com incorporação de farinha de Tenebrio molitor e Alphitobius diaperinus utilizando técnicas de impressão 3D",
    "set": "InFood",
    "ficheiro": 28
  },
  {
    "numero": 29,
    "autor": "Lisiane Fernandes de Carvalho",
    "titulo": "Fiambres híbridos com insetos comestíveis: Benefícios nutricionais em produtos cárneos sustentáveis",
    "set": "InFood",
    "ficheiro": 29
  },
  {
    "numero": 30,
    "autor": "Andreia Filipa-Silva",
    "titulo": "Desenvolvimento de metodologias de autenticidade por análise de DNA para a prevenção de fraudes em alimentos e matérias primas à base de insetos",
    "set": "InFood",
    "ficheiro": 30
  },
  {
    "numero": 31,
    "autor": "Maria Gabriela Basto de Lima",
    "titulo": "Cremes de barrar “Proteina +” com isolado proteico de Acheta domesticus",
    "set": "InFood",
    "ficheiro": 31
  },
  {
    "numero": 32,
    "autor": "Enrico Brigada",
    "titulo": "Implementação de Derivados de Tenebrio Molitor em Análogos de Bife Impressos em 3D",
    "set": "InFood",
    "ficheiro": 32
  },
  {
    "numero": 33,
    "autor": "Lisete M. Silva",
    "titulo": "Extração e caraterização de proteínas de inseto: uma alternativa sustentável para a alimentação",
    "set": "InFood",
    "ficheiro": 33
  },
  {
    "numero": 34,
    "autor": "Catarina V. Esteves",
    "titulo": "Extração, caracterização e clarificação de óleos de farinhas de insetos para alavancar o potencial do novo setor bioindustrial",
    "set": "InFood",
    "ficheiro": 34
  },
  {
    "numero": 35,
    "autor": "Norton Komora",
    "titulo": "Desempenho sensorial e nutricional de pastas de azeitonas e frutos secos enriquecidas com Tenebrio molitor",
    "set": "InFood",
    "ficheiro": 35
  },
  {
    "numero": 36,
    "autor": "Norton Komora",
    "titulo": "A aceitação sensorial e melhoria nutricional de maioneses chipotle contendo farinha integral de Acheta Domesticus",
    "set": "InFood",
    "ficheiro": 36
  },
  {
    "numero": 37,
    "autor": "Meroua FOUGHAR",
    "titulo": "O frass de larvas de Tenebrio molitor exerce um efeito bioestimulante nas plantas de alface, aumentando a produtividade para além da simples libertação de nutrientes ou melhoria das propriedades do solo",
    "set": "InFrass",
    "ficheiro": 37
  },
  {
    "numero": 38,
    "autor": "Clarice Silva e Souza",
    "titulo": "Caracterização do frass obtidos de diferentes fontes de estrumes",
    "set": "InFrass",
    "ficheiro": 38
  },
  {
    "numero": 39,
    "autor": "Clarice Silva e Souza",
    "titulo": "Uma Nova Fronteira: da produção de frass BSF aos solos agrícolas.",
    "set": "InFrass",
    "ficheiro": 39
  },
  {
    "numero": 40,
    "autor": "Marisa Santos",
    "titulo": "O impacto da biodigestão de diferentes subprodutos agroalimentares na composição do frass de Tenebrio molitor",
    "set": "InFrass",
    "ficheiro": 40
  },
  {
    "numero": 41,
    "autor": "Marisa Santos",
    "titulo": "Impacto do Frass de Tenebrio molitor na Produtividade da Cultura de Batata-Doce em Portugal: Uma Alternativa Sustentável aos Fertilizantes Convencionais",
    "set": "InFrass",
    "ficheiro": 41
  },
  {
    "numero": 42,
    "autor": "Leonor Martins",
    "titulo": "Avaliação do impacto do frass na saúde das plantas e do solo",
    "set": "InFrass",
    "ficheiro": 42
  },
  {
    "numero": 43,
    "autor": "Rafaela Fantatto",
    "titulo": "Método simples e eficiente para extração rápida de hemolinfa de larvas de mosca soldado negra",
    "set": "InIndustry",
    "ficheiro": 43
  },
  {
    "numero": 44,
    "autor": "Ana Rita Marques Silva",
    "titulo": "Acheta domesticus como fonte promissora e sustentável de ingredientes ativos para aplicação cosmética",
    "set": "InIndustry",
    "ficheiro": 44
  },
  {
    "numero": 45,
    "autor": "Bernardo Bastos",
    "titulo": "Cuidado da pele à base de Quitosano de Inseto",
    "set": "InIndustry",
    "ficheiro": 45
  },
  {
    "numero": 46,
    "autor": "Luísa Martins",
    "titulo": "Métodos sustentáveis para obtenção de quitina e quitosano",
    "set": "InIndustry",
    "ficheiro": 46
  },
  {
    "numero": 47,
    "autor": "Ana Paula C. Ribeiro",
    "titulo": "Métodos sustentáveis de produzir bioplásticos a partir do quitosano",
    "set": "InIndustry",
    "ficheiro": 47
  },
  {
    "numero": 48,
    "autor": "Rafaela Regina Fantatto",
    "titulo": "Avaliação de subprodutos vegetais como base alimentar para larvas de mosca soldado negro",
    "set": "Matérias Primas",
    "ficheiro": 48
  },
  {
    "numero": 49,
    "autor": "Marisa Santos",
    "titulo": "O papel dos insetos na valorização de subprodutos de pastelaria: a sustentabilidade nutricional de Tenebrio molitor",
    "set": "Matérias Primas",
    "ficheiro": 49
  },
  {
    "numero": 50,
    "autor": "Herminio Alves",
    "titulo": "Rumo à avaliação da sustentabilidade social e económica de produtos derivados de insetos",
    "set": "One Health",
    "ficheiro": 50
  },
  {
    "numero": 51,
    "autor": "Sara Filipa Mourão Santos da Silva",
    "titulo": "Avaliação da sustentabilidade social e económica de produtos derivados de insetos: contribuições metodológicas",
    "set": "One Health",
    "ficheiro": 51
  },
  {
    "numero": 52,
    "autor": "Joana Oliveira",
    "titulo": "Biorremediação por BSFL: Melhorar a segurança alimentar através do combate a agentes patogénicos nos resíduos alimentares",
    "set": "One Health",
    "ficheiro": 52
  }
]